import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { useUserDetail } from "Settings/User/Api/Query/useUserByIdQuery";
import { UserEditWidget } from "Settings/User/Widgets/UserEditWidget";
import { PageContainer } from "Shared/Components/Container";
import { Box, CircularProgress } from "@mui/material";
import { useParams } from "react-router";

const userResources = Resources.base.user;

export const EditUserPage = () => {
	const { t } = useResource();
	const { id: userId } = useParams();
	const paramsUserId = userId ? Number(userId) : undefined;
	const { data: user, isLoading } = useUserDetail(paramsUserId);

	if (isLoading) {
		return (
			<Box width="100%" display="flex" justifyContent="center" mt={5}>
				<CircularProgress />
			</Box>
		);
	}

	return (
		<PageContainer title={t(userResources.edit)} description="User management">
			{user ? <UserEditWidget user={user} userId={user.id} /> : <>NO DATA</>}
		</PageContainer>
	);
};
